import { CardLinkModel } from "@models/card-link.model";
import { BaseService } from "./base.service";
import gateway from "@interceptors/gateway.interceptor";

class CardLinkService extends BaseService {
    public deleteCardLink = async (id: number) => {
        const url = `/card-link/delete/${id}`
        const response = await gateway.delete(url)
        return response.data
    }
    public createCardLink = async (idCardInfoParent: string, formData: FormData, cardLinkModel: CardLinkModel) => {
        const url = '/card-link/save';   
        const dto = this.cardLinkConverter.modelToDto(cardLinkModel);
        const bodyJsonString = JSON.stringify(dto);
        formData.append('body', new Blob([bodyJsonString], { type: 'application/json' }));
        const response = await gateway.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "idCardInfo": idCardInfoParent
            }
        })
        return response.data;
    }

    public updateCardLink = async (idParent: string,idCardLink: string, formData: FormData, cardLinkModel: CardLinkModel) => {
        const url = `/card-link/update/${idCardLink}`;
        const dto = this.cardLinkConverter.modelToDto(cardLinkModel);
        const bodyJsonString = JSON.stringify(dto);
        formData.append('body', new Blob([bodyJsonString], { type: 'application/json' }));
        const response = await gateway.put(url,formData,{
             headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "idCardInfo": idParent
            }
        });
        return response.data;
    }

    public findCardLinkById = async (idCardLink: string) => {
        const url = `/card-link/find/${idCardLink}`;
        const response = await gateway.get(url);
        return response.data;
    }
}

export default new CardLinkService();